import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import SEO from "../components/seo"
import withLayout from "../components/layout/withLayout"
import useTranslation from "../mlang/useTranslation"
import BackgroundImage from "gatsby-background-image"
import Crystals from "../components/crystals"


const Components = () => {
  const t = useTranslation('components')
  const crystalsText = t.crystals

  const { allFile: { components }, more: { crystals: crystalsImage } } = useStaticQuery(graphql`
  {
    allFile(filter: {relativeDirectory: {eq: "components"}}, sort: {fields: name}) {
      components: nodes {
        name,
        image: childImageSharp {
          fluid(quality: 100) {
            originalName,
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
    more: allFile(filter: {relativeDirectory: {regex: "/components//"}}) {
      crystals: nodes {
        name,
        image: childImageSharp {
          fluid(quality: 100) {
            originalName,
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }`)

  return (
    <div className="components">
      <SEO title={t.title} />
      <h2 className="appeal accent">{t.p1}</h2>
      <div className="page">
        <div className="wrapper">
          {components.map(component => {
            const { name, image } = component
            const { title, description } = t.list[`${name}`]

            return (
              <div key={name} className="card">
                <BackgroundImage
                  className="image"
                  fluid={image.fluid}
                  alt={image.originalName}
                />
                <div className="card__text">
                  <h3>{title.getHTML()}</h3>
                  <p>{description}</p>
                </div>
              </div>
            )
          })}
        </div>
        <Crystals
          images={crystalsImage}
          text={crystalsText}
          className="crystals card"
        />
      </div>
      <h2 className="appeal accent">{t.p1}</h2>
    </div>
  )
}

export default withLayout(Components)